// MAD TURBO — i18n translations (LT default, EN fallback)
export const translations = {
  lt: {
    // Nav
    nav: {
      home: "Pradžia",
      about: "Apie",
      services: "Paslaugos",
      vehicles: "Automobiliai",
      partners: "Partneriai",
      process: "Procesas",
      faq: "D.U.K.",
      contact: "Kontaktai",
      book: "Konsultacija",
    },
    // Common
    common: {
      readMore: "Skaityti daugiau",
      bookConsultation: "Užsakyti konsultaciją",
      viewServices: "Peržiūrėti paslaugas",
      requestQuote: "Užklausa",
      backToServices: "Grįžti į paslaugas",
      backToVehicles: "Grįžti į automobilius",
      loading: "Kraunama...",
      submitting: "Siunčiama...",
      success: "Užklausa gauta. Susisieksime greitai.",
      error: "Įvyko klaida. Bandykite dar kartą.",
      required: "Privalomas laukas",
      language: "Kalba",
      copyright: "© {year} MAD TURBO. Visos teisės saugomos.",
      relatedServices: "Susijusios paslaugos",
      benefits: "Nauda",
      suitableVehicles: "Tinkami automobiliai",
      expectedResults: "Laukiami rezultatai",
      faqTitle: "Dažniausiai užduodami klausimai",
      ctaTitle: "Pasiruošę kitam žingsniui?",
      ctaText: "Užsakykite konsultaciją ir aptarkime Jūsų automobilio potencialą.",
      submitAnother: "Siųsti dar vieną užklausą",
    },
    successCards: {
      contactTitle: "✅ Ačiū!",
      contactBody: "Jūsų užklausa sėkmingai išsiųsta.\nSu Jumis susisieksime kaip įmanoma greičiau.",
      partnerTitle: "✅ Ačiū!",
      partnerBody: "Jūsų partnerystės paraiška sėkmingai gauta.\nSu Jumis susisieksime kaip įmanoma greičiau.",
    },
    labels: {
      overview: "Apžvalga",
      category: "Kategorija",
      platform: "Platforma",
      related: "Susiję",
      social: "Socialiniai tinklai",
      consultation: "Konsultacija",
      engines: "Varikliai",
      ecus: "ECU",
      vehicleDatabase: "Automobilių bazė",
      serviceArea: "Aptarnaujama vieta",
      cityLevelNote: "Miesto lygio žymė. Tikslus dirbtuvių adresas — sutartas iš anksto.",
    },
    // Home
    home: {
      kicker: "MAD TURBO — Šiauliai, Lietuva",
      heroTitle: "Galia be kompromisų.",
      heroSubtitle: "Profesionalus ECU kalibravimas, diagnostika ir programinės įrangos inžinerija moderniems benzininiams ir dyzeliniams automobiliams.",
      stats: {
        title: "Kodėl klientai renkasi mus",
        items: [
          { k: "Profesionalus ECU kalibravimas", v: "Individualus kiekvienam automobiliui" },
          { k: "Bench programavimas", v: "Tiesiogiai ant ECU stalo" },
          { k: "Boot programavimas", v: "Sudėtingiems modeliams" },
          { k: "OBD programavimas", v: "Per diagnostikos jungtį" },
          { k: "Originalaus ECU atsarginė kopija", v: "Prieš kiekvieną kalibravimą" },
          { k: "Nauja AutoTuner įranga", v: "Naujausia rinkoje" },
          { k: "Greitas darbo tempas", v: "Grąžinimas tą pačią dieną" },
        ],
      },
      why: {
        title: "Kodėl MAD TURBO",
        subtitle: "Kokybė vietoje kiekio. Kiekvienas automobilis gauna individualų sprendimą.",
        items: [
          { t: "Inžinerinis požiūris", d: "Programinė įranga kuriama individualiai kiekvienam projektui." },
          { t: "Individualus ECU software", d: "Jokių universalių failų. Kiekviena kalibracija — unikali." },
          { t: "Profesionali diagnostika", d: "Detali automobilio analizė prieš darbą ir po jo." },
          { t: "Moderni įranga", d: "AutoTuner ir profesionalūs diagnostikos įrenginiai." },
          { t: "Saugus kalibravimas", d: "Ribos, kurios saugo variklį ir transmisiją." },
          { t: "Techninis palaikymas", d: "Palaikome klientą ir po paslaugos suteikimo." },
          { t: "Optimizacija pagal automobilį", d: "Kiekvienas motoras — kitoks. Kalibruojame pagal jį." },
          { t: "Patikimas rezultatas", d: "Nuspėjamas galios prieaugis ir ilgaamžiškumas." },
        ],
      },
      servicesPreview: {
        title: "Pagrindinės paslaugos",
        subtitle: "Nuo Stage 1 iki individualaus ECU inžinerijos projekto.",
      },
      brandsTitle: "Palaikomos markės",
    },
    // About
    about: {
      title: "Apie MAD TURBO",
      subtitle: "Inžinerija pirmiausia. Volume — antraeilis dalykas.",
      body: [
        "MAD TURBO — premium ECU kalibravimo studija Šiauliuose. Specializuojamės individualiame ECU software inžinerijoje moderniems benzininiams ir dyzeliniams automobiliams.",
        "Kiekvienas projektas mums — atskira užduotis. Nekopijuojame failų. Nemažiname darbo apimties dėl greičio. Kiekviena kalibracija kuriama pagal konkretaus automobilio konfigūraciją ir kliento tikslus.",
        "Naudojame naujausią AutoTuner įrangą, profesionalią diagnostikos ekipuotę ir kruopščiai dirbame kiekviename projekto etape.",
      ],
      values: [
        { t: "Kokybė", d: "Kruopštumas kiekvienoje detalėje." },
        { t: "Patikimumas", d: "Rezultatas, kuriuo galima pasitikėti." },
        { t: "Skaidrumas", d: "Aiškiai apibrėžti tikslai ir procesas." },
      ],
    },
    // Process
    process: {
      title: "Kaip mes dirbame",
      subtitle: "Septyni žingsniai — nuo konsultacijos iki pristatymo klientui.",
      steps: [
        { t: "Konsultacija", d: "Aptariame automobilį, tikslus ir galimybes." },
        { t: "Diagnostika", d: "Pilnas techninis patikrinimas prieš darbą." },
        { t: "Originalus ECU atsarga", d: "Išsaugome originalią programinę įrangą." },
        { t: "Software inžinerija", d: "Kuriame kalibraciją individualiai." },
        { t: "Programavimas", d: "OBD, Bench arba Boot metodais." },
        { t: "Testavimas", d: "Techninis patikrinimas ir data logai." },
        { t: "Pristatymas klientui", d: "Aptariame rezultatą ir techninį palaikymą." },
      ],
    },
    // Partners
    partners: {
      title: "Tapkite MAD TURBO partneriu",
      subtitle: "Kviečiame servisus, atstovybes ir įmones prisijungti prie mūsų techninio tinklo.",
      target: [
        { t: "Automobilių servisai", d: "Pridėkite ECU paslaugas prie savo pasiūlymo." },
        { t: "Atstovybės", d: "Aptarnaukite klientus po garantijos." },
        { t: "Performance dirbtuvės", d: "Techninis partneris Stage 3 projektams." },
        { t: "Automobilių parkai", d: "Ekonominis kalibravimas fleet automobiliams." },
      ],
      benefits: {
        title: "Partnerystės nauda",
        items: [
          "Techninis palaikymas kiekvienam projektui",
          "Konkurencingos partnerių kainos",
          "Greitas darbo tempas",
          "Individualūs sprendimai",
          "Profesionali dokumentacija",
          "Reguliarus training ir naujienos",
        ],
      },
      form: {
        title: "Partnerystės užklausa",
        fields: {
          business_name: "Įmonės pavadinimas",
          contact_person: "Kontaktinis asmuo",
          phone: "Telefonas",
          email: "El. paštas",
          website: "Svetainė",
          city: "Miestas",
          business_type: "Veiklos tipas",
          monthly_volume: "Mėnesinis automobilių kiekis",
          equipment: "Turima įranga",
          message: "Žinutė",
          submit: "Tapti MAD TURBO partneriu",
        },
      },
    },
    // Contact
    contact: {
      title: "Susisiekite",
      subtitle: "Šiauliai, Lietuva. Skambinkite, rašykite arba užpildykite formą.",
      hoursTitle: "Darbo laikas",
      hours: [
        { d: "Pirmadienis – Penktadienis", h: "09:00 – 18:00" },
        { d: "Šeštadienis", h: "Pagal susitarimą" },
        { d: "Sekmadienis", h: "Nedirbame" },
      ],
      form: {
        title: "Konsultacijos užklausa",
        fields: {
          name: "Vardas",
          phone: "Telefonas",
          email: "El. paštas",
          vehicle: "Automobilis",
          engine: "Variklis",
          registration: "Valst. Nr.",
          service: "Pageidaujama paslauga",
          message: "Žinutė",
          submit: "Siųsti užklausą",
        },
      },
      addressTitle: "Adresas",
      address: "Šiauliai, Lietuva",
      phoneLabel: "Telefonas",
      emailLabel: "El. paštas",
    },
    // FAQ
    faq: {
      title: "Dažniausiai užduodami klausimai",
      subtitle: "Techniniai atsakymai apie ECU kalibravimą, saugumą, garantiją ir rezultatus.",
    },
    // Vehicles
    vehicles: {
      title: "Automobilių bazė",
      subtitle: "Palaikomos markės, varikliai ir ECU. Ieškoma pagal gamintoją.",
      searchPlaceholder: "Ieškoti gamintojo...",
      popularEngines: "Populiarūs varikliai",
      supportedEcus: "Palaikomi ECU",
      availableServices: "Prieinamos paslaugos",
      commonUpgrades: "Dažni patobulinimai",
    },
    // Services
    services: {
      title: "Paslaugos",
      subtitle: "Nuo Stage 1 iki individualios ECU inžinerijos ir OBD/Bench/Boot programavimo.",
      categoryPerformance: "Galios kalibravimas",
      categoryEconomy: "Ekonominis kalibravimas",
      categoryEmissions: "Emisijos ir DPF",
      categoryProgramming: "Programavimas ir diagnostika",
      categoryTransmission: "Transmisija",
    },
    // Footer
    footer: {
      tagline: "More Boost. More Madness.",
      navigation: "Navigacija",
      servicesCol: "Paslaugos",
      legal: "Teisinė informacija",
      getInTouch: "Susisiekite",
      getInTouchText: "Tiesioginis kontaktas su MAD TURBO komanda. Jokių formų — tik greiti atsakymai ir kokybiškos konsultacijos.",
      bookConsultCta: "Užsakyti konsultaciją",
      privacy: "Privatumo politika",
      cookies: "Slapukų politika",
      terms: "Taisyklės ir sąlygos",
      followUs: "Sekite mus",
    },
    // Cookies
    cookie: {
      text: "Naudojame slapukus svetainės funkcionalumui ir statistikai. Naršydami sutinkate su mūsų slapukų politika.",
      accept: "Sutinku",
      decline: "Nesutinku",
    },
    // 404
    notFound: {
      title: "404 — Klaidos kodas",
      subtitle: "Šio kelio ECU dar neatpažįsta.",
      cta: "Grįžti į pradžią",
    },
    // Admin
    admin: {
      login: {
        title: "Administratoriaus prisijungimas",
        email: "El. paštas",
        password: "Slaptažodis",
        submit: "Prisijungti",
        error: "Neteisingi prisijungimo duomenys",
        rateLimit: "Per daug bandymų. Pabandykite po kelių minučių.",
      },
      dashboard: {
        title: "MAD TURBO valdymas",
        logout: "Atsijungti",
        contacts: "Kontaktų užklausos",
        partners: "Partnerių užklausos",
        stats: "Statistika",
        noData: "Duomenų nėra.",
        updateStatus: "Būsena",
        statusUpdated: "Būsena atnaujinta",
        statusFailed: "Nepavyko atnaujinti būsenos",
        statuses: {
          new: "Nauja",
          in_progress: "Vykdoma",
          done: "Užbaigta",
          archived: "Archyvuota",
        },
      },
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      vehicles: "Vehicles",
      partners: "Partners",
      process: "Process",
      faq: "FAQ",
      contact: "Contact",
      book: "Consultation",
    },
    common: {
      readMore: "Read more",
      bookConsultation: "Book consultation",
      viewServices: "View services",
      requestQuote: "Request quote",
      backToServices: "Back to services",
      backToVehicles: "Back to vehicles",
      loading: "Loading...",
      submitting: "Sending...",
      success: "Enquiry received. We will be in touch shortly.",
      error: "Something went wrong. Please try again.",
      required: "Required",
      language: "Language",
      copyright: "© {year} MAD TURBO. All rights reserved.",
      relatedServices: "Related services",
      benefits: "Benefits",
      suitableVehicles: "Suitable vehicles",
      expectedResults: "Expected results",
      faqTitle: "Frequently asked questions",
      ctaTitle: "Ready for the next step?",
      ctaText: "Book a consultation and let's unlock the true potential of your vehicle.",
      submitAnother: "Submit another enquiry",
    },
    successCards: {
      contactTitle: "✅ Thank you!",
      contactBody: "Your enquiry has been successfully submitted.\nWe will contact you as soon as possible.",
      partnerTitle: "✅ Thank you!",
      partnerBody: "Your partnership application has been received.\nWe will contact you as soon as possible.",
    },
    labels: {
      overview: "Overview",
      category: "Category",
      platform: "Platform",
      related: "Related",
      social: "Social",
      consultation: "Consultation",
      engines: "Engines",
      ecus: "ECUs",
      vehicleDatabase: "Vehicle database",
      serviceArea: "Service area",
      cityLevelNote: "City-level marker. Exact workshop address arranged in advance.",
    },
    home: {
      kicker: "MAD TURBO — Šiauliai, Lithuania",
      heroTitle: "Performance without compromise.",
      heroSubtitle: "Professional ECU calibration, diagnostics and software engineering for modern petrol and diesel vehicles.",
      stats: {
        title: "Why clients trust us",
        items: [
          { k: "Professional ECU calibration", v: "Custom for every vehicle" },
          { k: "Bench programming", v: "Direct on the ECU bench" },
          { k: "Boot programming", v: "For complex platforms" },
          { k: "OBD programming", v: "Through diagnostic port" },
          { k: "Original ECU backup", v: "Before every calibration" },
          { k: "Latest AutoTuner equipment", v: "Newest on the market" },
          { k: "Fast turnaround", v: "Same-day delivery" },
        ],
      },
      why: {
        title: "Why MAD TURBO",
        subtitle: "Quality over volume. Every vehicle receives a custom solution.",
        items: [
          { t: "Engineering-first approach", d: "Software developed individually for every project." },
          { t: "Custom ECU software", d: "No generic files. Every calibration is unique." },
          { t: "Professional diagnostics", d: "Detailed vehicle analysis before and after work." },
          { t: "Modern equipment", d: "AutoTuner and professional diagnostic hardware." },
          { t: "Safe calibration", d: "Limits that protect engine and transmission." },
          { t: "Technical support", d: "We stand behind our work after delivery." },
          { t: "Vehicle-specific optimization", d: "Every engine is different — we calibrate accordingly." },
          { t: "Reliable results", d: "Predictable gains and long-term durability." },
        ],
      },
      servicesPreview: {
        title: "Core services",
        subtitle: "From Stage 1 to individual ECU engineering projects.",
      },
      brandsTitle: "Supported brands",
    },
    about: {
      title: "About MAD TURBO",
      subtitle: "Engineering first. Volume second.",
      body: [
        "MAD TURBO is a premium ECU calibration studio based in Šiauliai, Lithuania. We specialize in individual ECU software engineering for modern petrol and diesel vehicles.",
        "Every project is treated separately. We do not copy files. We do not cut corners for speed. Every calibration is developed according to the specific vehicle configuration and the client's goals.",
        "We work with the latest AutoTuner equipment, professional diagnostic tools and meticulous attention at every stage of the project.",
      ],
      values: [
        { t: "Quality", d: "Precision in every detail." },
        { t: "Reliability", d: "Results you can trust." },
        { t: "Transparency", d: "Clear goals and a clear process." },
      ],
    },
    process: {
      title: "How we work",
      subtitle: "Seven steps — from consultation to customer delivery.",
      steps: [
        { t: "Consultation", d: "We discuss the vehicle, goals and options." },
        { t: "Diagnostics", d: "Full technical check before any work." },
        { t: "Original ECU backup", d: "We save the original software." },
        { t: "Software development", d: "We build calibration individually." },
        { t: "Programming", d: "Via OBD, Bench or Boot." },
        { t: "Testing", d: "Technical check and data logs." },
        { t: "Customer delivery", d: "We discuss results and support." },
      ],
    },
    partners: {
      title: "Become a MAD TURBO partner",
      subtitle: "We invite garages, dealerships and companies to join our technical network.",
      target: [
        { t: "Automotive garages", d: "Add ECU services to your offering." },
        { t: "Dealerships", d: "Serve customers after warranty period." },
        { t: "Performance workshops", d: "Technical partner for Stage 3 builds." },
        { t: "Fleet companies", d: "Economy calibration for your fleet." },
      ],
      benefits: {
        title: "Partnership benefits",
        items: [
          "Technical support for every project",
          "Competitive partner pricing",
          "Fast turnaround",
          "Custom solutions",
          "Professional documentation",
          "Regular training and updates",
        ],
      },
      form: {
        title: "Partnership enquiry",
        fields: {
          business_name: "Business name",
          contact_person: "Contact person",
          phone: "Phone",
          email: "Email",
          website: "Website",
          city: "City",
          business_type: "Business type",
          monthly_volume: "Monthly vehicle volume",
          equipment: "Current equipment",
          message: "Message",
          submit: "Become a MAD TURBO partner",
        },
      },
    },
    contact: {
      title: "Contact",
      subtitle: "Šiauliai, Lithuania. Call, email or use the form.",
      hoursTitle: "Business hours",
      hours: [
        { d: "Monday – Friday", h: "09:00 – 18:00" },
        { d: "Saturday", h: "By appointment" },
        { d: "Sunday", h: "Closed" },
      ],
      form: {
        title: "Consultation enquiry",
        fields: {
          name: "Name",
          phone: "Phone",
          email: "Email",
          vehicle: "Vehicle",
          engine: "Engine",
          registration: "Reg. plate",
          service: "Desired service",
          message: "Message",
          submit: "Send enquiry",
        },
      },
      addressTitle: "Address",
      address: "Šiauliai, Lithuania",
      phoneLabel: "Phone",
      emailLabel: "Email",
    },
    faq: {
      title: "Frequently asked questions",
      subtitle: "Technical answers on ECU calibration, safety, warranty and results.",
    },
    vehicles: {
      title: "Vehicle database",
      subtitle: "Supported brands, engines and ECUs. Search by manufacturer.",
      searchPlaceholder: "Search manufacturer...",
      popularEngines: "Popular engines",
      supportedEcus: "Supported ECUs",
      availableServices: "Available services",
      commonUpgrades: "Common upgrades",
    },
    services: {
      title: "Services",
      subtitle: "From Stage 1 to bespoke ECU engineering and OBD/Bench/Boot programming.",
      categoryPerformance: "Performance calibration",
      categoryEconomy: "Economy calibration",
      categoryEmissions: "Emissions & DPF",
      categoryProgramming: "Programming & diagnostics",
      categoryTransmission: "Transmission",
    },
    footer: {
      tagline: "More Boost. More Madness.",
      navigation: "Navigation",
      servicesCol: "Services",
      legal: "Legal",
      getInTouch: "Get in touch",
      getInTouchText: "Direct line to the MAD TURBO team. No forms — just quick answers and expert consultations.",
      bookConsultCta: "Book a consultation",
      privacy: "Privacy Policy",
      cookies: "Cookie Policy",
      terms: "Terms & Conditions",
      followUs: "Follow us",
    },
    cookie: {
      text: "We use cookies for site functionality and analytics. By browsing you agree to our cookie policy.",
      accept: "Accept",
      decline: "Decline",
    },
    notFound: {
      title: "404 — Error code",
      subtitle: "This route is not recognised by the ECU.",
      cta: "Back to home",
    },
    admin: {
      login: {
        title: "Administrator login",
        email: "Email",
        password: "Password",
        submit: "Sign in",
        error: "Invalid credentials",
        rateLimit: "Too many attempts. Please try again in a few minutes.",
      },
      dashboard: {
        title: "MAD TURBO console",
        logout: "Sign out",
        contacts: "Contact enquiries",
        partners: "Partner enquiries",
        stats: "Statistics",
        noData: "No data yet.",
        updateStatus: "Status",
        statusUpdated: "Status updated",
        statusFailed: "Failed to update status",
        statuses: {
          new: "New",
          in_progress: "In progress",
          done: "Done",
          archived: "Archived",
        },
      },
    },
  },
};
